import React, { useState, useContext, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './ui/pages/LoginPage';
import InventoryPage from './ui/pages/InventoryPage';
import './App.css';
import BannersPage from './ui/pages/BannersPage';
import OrdersPage from './ui/pages/OrdersPage';
import GroupingsPage from './ui/pages/GroupingsPage';
import { LoadingContext } from './LoadingContext';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { setSessionJSON } from './utils/SessionUtils';
import keycloak, { setupTokenExpirationHandler } from './ui/components/keyclock';
import ProtectedRoute from './ProtectedRoute';
import SplashScreen from './ui/components/SplashScreen';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showSplash, setShowSplash] = useState(false);
  const navigate = useNavigate();
  const { loading, error, setError } = useContext(LoadingContext);
  const initialized = useRef(false);

  useEffect(() => {
    // Set up token expiration handler when component mounts
    if (initialized.current) {
      setupTokenExpirationHandler(() => {
        // Handle token expiration
        setSessionJSON("login-data", "");
        navigate("/", { replace: true });
      });
    }
  }, [navigate]);

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
    setShowSplash(true);
    // Set up token expiration listener after successful login
    setupTokenExpirationHandler(() => {
      setSessionJSON("login-data", "");
      navigate("/", { replace: true });
    });
    navigate('/items', { replace: true });
  };

  const handleLogout= () => {
      setSessionJSON("login-data","")
      if (!initialized.current) {
        try{
          keycloak.init().then(authenticated => {
            keycloak.logout().then(() => {
              navigate("/", { replace: true });
            });
          });
        } catch (error) {
          console.error("Error during logout:", error);
          keycloak.logout().then(() => {
            navigate("/", { replace: true });
          })
        }
      }else{
        keycloak.init().then(authenticated => {
            keycloak.logout().then(() => {
              navigate("/", { replace: true });
            });
          });
      }
    };

  return (
    <>
      {/* Loading Backdrop */}
      <Backdrop open={loading} style={{ zIndex: 1301 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Error Snackbar */}
      <Snackbar
        open={!!error}
        autoHideDuration={6000}
        onClose={() => setError(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MuiAlert onClose={() => setError(null)} severity="error" sx={{ width: '100%' }}>
          {error}
        </MuiAlert>
      </Snackbar>

      {/* Loading Splash Screen */}
      <SplashScreen show={showSplash} />

      <Routes>
        <Route
          path="/"
          element={<LoginPage onLoginSuccess={handleLoginSuccess} />}
        />
        <Route
          path="/items"
          element={
          <ProtectedRoute><InventoryPage  handleLogout={handleLogout} onReady={() => setShowSplash(false)} /></ProtectedRoute>
          }
        />
        <Route
          path="/banners"
          element={
          <ProtectedRoute><BannersPage handleLogout={handleLogout} /></ProtectedRoute>
          }
        />
        <Route
          path="/groupings"
          element={
          <ProtectedRoute><GroupingsPage handleLogout={handleLogout} /></ProtectedRoute>
          }
        />

        <Route
          path="/orders"
          element={
          <ProtectedRoute><OrdersPage handleLogout={handleLogout} /></ProtectedRoute>
          }
        />


        <Route
          path="*"
          element={<Navigate to={isLoggedIn ? "/items" : "/"} replace />}
        />
      </Routes>
    </>
  );
}



function AppWithRouter() {
  // Use /store as the base path for all routes
  return (
    <Router>
      <App />
    </Router>
  );
}

export default AppWithRouter;
